/* Capo's Den fire homepage: hero rotation (pauses on hover/focus, off for reduced motion) and the type lanes. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-fz-hero]').forEach((hero) => {
    if (hero.dataset.ready) return; hero.dataset.ready = '1';
    const slides = [...hero.querySelectorAll('[data-fz-slide]')], picks = [...hero.querySelectorAll('[data-fz-pick]')];
    if (slides.length < 2) return;
    const DUR = 7000; hero.style.setProperty('--fz-dur', DUR / 1000 + 's');
    let i = 0, timer = null, paused = false;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { s.hidden = k !== i; s.classList.toggle('is-on', k === i); });
      picks.forEach((p, k) => { const on = k === i; p.classList.toggle('is-on', false); p.setAttribute('aria-selected', String(on)); if (on) { void p.offsetWidth; p.classList.add('is-on'); } });
      schedule();
    };
    const schedule = () => { clearTimeout(timer); if (!reduce && !paused) timer = setTimeout(() => show(i + 1), DUR); };
    picks.forEach((p, k) => p.addEventListener('click', () => show(k)));
    const pause = (on) => { paused = on; hero.classList.toggle('is-paused', on); if (on) clearTimeout(timer); else schedule(); };
    hero.addEventListener('pointerenter', () => pause(true)); hero.addEventListener('pointerleave', () => pause(false));
    hero.addEventListener('focusin', () => pause(true)); hero.addEventListener('focusout', () => pause(false));
    document.addEventListener('visibilitychange', () => pause(document.hidden));
    schedule();
  });
  document.querySelectorAll('[data-fz-lanes]').forEach((root) => {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const lanes = [...root.querySelectorAll('[data-fz-lane]')];
    const open = (lane) => lanes.forEach((l) => { const on = l === lane; l.classList.toggle('is-on', on); l.querySelector('.fz-lane-tab').setAttribute('aria-expanded', String(on)); });
    lanes.forEach((l) => {
      l.querySelector('.fz-lane-tab').addEventListener('click', () => open(l));
      l.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && matchMedia('(min-width: 981px)').matches) open(l); });
    });
  });
})();
